// this component was automatically generated by IconGlyph.template.js
import React from 'react';
import { TestId } from '@trello/test-ids';

import { Icon, IconColor, IconSize } from '../src/components/Icon';

export interface GlyphProps {
  /**
   * A string that is applied as an aria attribute on the icon. Usually it
   * matches up with the display name of the icon
   * @default If no label is provided, it will fallback to the name of the icon
   */
  label?: string;
  /**
   * The color that the Icon should be rendered as.
   * @default @icon-default-color (#42526E)
   */
  color?: IconColor;
  /**
   * The size to render the Icon size.
   * @default "medium"
   */
  size?: IconSize;
  /**
   * A string that gets placed as a data attribute (data-test-id) onto the
   * Icon wrapper so that our
   * smoketest can properly target and test the component
   * @default undefined
   */
  testId?: TestId;
  // Escape hatches
  /**
   * ⚠️ DO NOT USE THIS PROP UNLESS YOU REALLY REALLY HAVE TO.
   *
   * Places a class name on the Icon (more specifically, the svg itself). This
   * is placed in addition to the classes already placed on the Icon. This is
   * placed directly onto the SVG via the glyph templates that are
   * generated by IconGlyph.template.js
   *
   * Please refrain from using this unless absolutely necessary.
   * @default undefined
   */
  dangerous_className?: string;
}

const OrganizationIconGlyph = () => {
  return (
    <svg
      width="24"
      height="24"
      role="presentation"
      focusable="false"
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.505 5.672a4.968 4.968 0 00-1.985-.645 4 4 0 116.521 4.572A8.003 8.003 0 0122 17a1 1 0 01-1 1h-2.223a8.936 8.936 0 00-.713-2h1.853a6.005 6.005 0 00-5.03-4.935 5.016 5.016 0 00-.03-2.257 2 2 0 10-2.352-3.136zM6 10c0 .992.361 1.9.959 2.598A8.002 8.002 0 002 20a1 1 0 001 1h14a1 1 0 001-1 8.002 8.002 0 00-4.959-7.402A4 4 0 106 10zm4 2a2 2 0 100-4 2 2 0 000 4zm0 2a6.002 6.002 0 015.917 5H4.083A6.002 6.002 0 0110 14z"
        fill="currentColor"
      />
    </svg>
  );
};

export const OrganizationIcon: React.FunctionComponent<GlyphProps> = (
  props,
) => {
  const { testId, dangerous_className, size, color, label } = props;
  return (
    <Icon
      testId={testId}
      size={size}
      dangerous_className={dangerous_className}
      color={color}
      label={label || 'OrganizationIcon'}
      glyph={OrganizationIconGlyph}
    />
  );
};
